<template>
  <div class="w1200 create2">
      <div class="mtitle2 cen mt_40 mb_40">请选择所需模块</div>
       <TreeNode
      v-for="node in treeData" 
      :key="node.id"
      :node="node" 
      :level="0"
      @toggle="handleToggle"
      @check="handleCheck"
      @child-check="handleChildCheck"
    />

        <div class="flex flex-v mt_30 mb_40">
          <div class="flex-1 f20">已选{{num}}个模块，费用：<span class="red">￥{{money.toFixed(2)}}</span></div>
        <el-button class="syb" >上一步</el-button>
        <el-button type="primary" class="xyb" @click="getSelectedData">下一步</el-button>
        </div>


        <el-dialog
        title="支付费用" :close-on-click-modal="false" :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        width="500px">
        <div slot="title" class="dialog-title">
              支付费用 <span class="red">￥{{money.toFixed(2)}}</span>
        </div>
        <div class="pad30">
            <div class="flex flex-c flexx-v">
                <el-radio-group v-model="radio" @change="paychange">
                  <el-radio :label="1"><img style="width:30px;height:30px;margin-right:5px;" src="@/assets/weixin.png">微信支付</el-radio>
                  <el-radio :label="2"><img style="width:30px;height:30px;margin-right:5px;" src="@/assets/zhifubao.png">支付宝支付</el-radio>
                </el-radio-group>
            </div>
            <div class="ewm">
               <canvas ref="qrcodeCanvas"></canvas>
            </div>
            <div class="tip" v-if="radio==1">请用微信扫码支付</div>
            <div class="tip" v-else>请用支付宝扫码支付</div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import {getMklistTree,createOrder,payOrder,checkOrderPay,payOrderYuer } from "@/api/index.js"
import TreeNode from './TreeNode.vue'
import QRCode from 'qrcode'

export default {
   components: {
    TreeNode
  },
  data() {
    return {
      dialogVisible:false,
      qrcodeDataURL: '',
      radio:1,
      treeData: [],
      selectedData:[],
      num:0,
      money:0,
      xzmkids:'',
      timer:null,
      payid:''
    }
  },
   mounted() {
     getMklistTree({yjsjlx_id:this.$route.query.yjsjlx_id,bzfl_id:this.$route.query.bzfl_id}).then(res=>{
        if(res.code==1){
          this.treeData=this.addCheckedField(res.data.mkList)
        }
     })
    },
    beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 清除定时器
      this.timer = null; // 清除引用，避免内存泄漏
    }
  },
  methods:{
   
     addCheckedField(tree) {
  if (!tree || typeof tree !== 'object') return tree;
  
  if (Array.isArray(tree)) {
    return tree.map(item => this.addCheckedField(item));
  }
  
  const newNode = { ...tree, checked: false,expanded:false };
  
  // 递归处理子节点
  if (newNode.hasOwnProperty('child') && Array.isArray(newNode.child)) {
    newNode.child = this.addCheckedField(newNode.child);
  }
  
  // 处理其他可能包含子节点的属性
  Object.keys(newNode).forEach(key => {
    if (key !== 'child' && typeof newNode[key] === 'object' && newNode[key] !== null) {
      newNode[key] = this.addCheckedField(newNode[key]);
    }
  });
  
  return newNode;
},
    getSelectedData() {
      createOrder({yjsjlx_id:this.$route.query.yjsjlx_id,bzfl_id:this.$route.query.bzfl_id,xzmkids:this.xzmkids}).then(res=>{
        
         if(res.code==1){
              this.payid=res.data.id;
              if(this.$store.state.usertype=='1'){
                 this.pay(res.data.id)
              }else{
                 this.pay2(res.data.id)
              }
             
             
         }
      })
     
    },
     paychange(){
       clearInterval(this.timer);
       this.timer=null;
          if(this.radio==1){
             this.pay(this.payid)
         }else{
              location.href=this.$imgurl('/api/yixue/payOrder?id='+this.payid+'&type=2')
         }
    },
    setimg(url){
       QRCode.toCanvas(this.$refs.qrcodeCanvas, url, {
          width:200,
          margin: 2,
        })
    },
    pay(id){
        payOrder({id:id,type:this.radio}).then(res=>{
          if(res.code==1){
            this.dialogVisible=true;
             setTimeout(() => {
              this.setimg(res.data.code_url)
            }, 500);
            this.timer=setInterval(() => {
                       this.checkorder(id)
             }, 1000);
          }
        })
    },
    checkorder(id){
      checkOrderPay({id:id}).then(res=>{
        if(res.code==1){
            if(res.data.orderstatus==2){
              clearInterval(this.timer);
              this.timer=null
              this.$message({
                    message: '支付成功',
                    type: 'success'
                  });
                  this.$router.push('/doc?id='+id)
            }
        }
      })
    },
    pay2(id){
      payOrderYuer({id:id}).then(res=>{
          if(res.code==1){
             this.$message({
                    message: '支付成功',
                    type: 'success'
                  });
                  this.$router.push('/doc?id='+id)
          }
        })
    },
    collectSelectedNodes(nodes, level) {
      for (let node of nodes) {
        if (node.checked) {
          this.selectedData.push({
            id: node.id,
            name: node.name,
            level: level,
            checktype: node.checktype,
            pid:node.pid,
            checked:node.checked,
            grprice:node.grprice,
            jgprice:node.jgprice,
            syprice:node.syprice
          })
        }
        if (node.child && node.child.length > 0) {
          this.collectSelectedNodes(node.child, level + 1)
        }
      }
    },
     handleToggle(nodeId) {
      this.toggleNode(this.treeData, nodeId)
    },
    toggleNode(nodes, nodeId) {
      for (let node of nodes) {
        if (node.id === nodeId) {
          node.expanded = !node.expanded
          return true
        }
        if (node.child && this.toggleNode(node.child, nodeId)) {
          return true
        }
      }
      return false
    },
    calculateSums(data) {
  // 构建树形结构
  const buildTree = (items, pid = 0) => {
    return items
      .filter(item => item.pid === pid)
      .map(item => ({
        ...item,
        children: buildTree(items, item.id)
      }));
  };

  const treeData = buildTree(data);
  
  // 递归计算最底层的价格总和
  const calculateLeafSums = (nodes) => {
    let jgSum = 0;
    let sySum = 0;
    let grSum = 0;

    nodes.forEach(node => {
      if (node.children && node.children.length > 0) {
        // 如果有子节点，递归计算子节点的总和
        const childSums = calculateLeafSums(node.children);
        jgSum += childSums.jgSum;
        sySum += childSums.sySum;
        grSum += childSums.grSum;
      } else {
        // 如果没有子节点，直接累加当前节点的价格
        jgSum += parseFloat(node.jgprice || 0);
        sySum += parseFloat(node.syprice || 0);
        grSum += parseFloat(node.grprice || 0);
      }
    });

    return { jgSum, sySum, grSum };
  };

  return calculateLeafSums(treeData);
},
    getnumandmoney(){
      this.selectedData = []
      this.collectSelectedNodes(this.treeData, 0)
      console.log('选中的数据:', this.selectedData)
      this.num=this.selectedData.filter(item=>item.pid==0).length
      this.xzmkids=(this.selectedData.map(item=>{return item.id})).join()

      const result =this.calculateSums(this.selectedData);
        if(this.$store.state.usertype=='1'){
             this.money=result.grSum
          }else if(this.$store.state.usertype=='2'){
              this.money=result.jgSum
         }else{
          this.money=result.sySum
         }
    },
    handleCheck(nodeId, checked) {
      this.updateNodeCheck(this.treeData, nodeId, checked)
      this.getnumandmoney()
    },
    handleChildCheck(nodeId, checked) {
      this.updateNodeCheck(this.treeData, nodeId, checked)
      this.getnumandmoney()
    },
    updateNodeCheck(nodes, nodeId, checked) {
      for (let node of nodes) {
        if (node.id === nodeId) {
          node.checked = checked
          
          // 如果取消选择父级，递归取消所有子级
          if (!checked && node.child) {
            this.uncheckAllChildren(node.child)
          }
          return true
        }
        if (node.child && this.updateNodeCheck(node.child, nodeId, checked)) {
          // 如果子级被选中，自动选中父级
          if (checked) {
            node.checked = true
          }
          // 如果子级取消选择，检查是否还有其他子级被选中
          else {
            const hasCheckedChildren = this.hasCheckedChildren(node.child)
            if (!hasCheckedChildren) {
              node.checked = false
            }
          }
          return true
        }
      }
      return false
    },
    uncheckAllChildren(child) {
      child.forEach(child => {
        child.checked = false
        if (child.child) {
          this.uncheckAllChildren(child.child)
        }
      })
    },
    hasCheckedChildren(child) {
      return child.some(child => {
        return child.checked || (child.child && this.hasCheckedChildren(child.child))
      })
    }
  }
};
</script>

<style lang="less">
.create2 {
   
   .sel {width:100%;}
   

    .syb {background:#E8EFF6;font-size:20px;width:240px;height:50px;margin-right:20px;}
    .xyb {background:#2397CA;font-size:20px;width:240px;height:50px;}
    .dialog-title {font-weight: bold;font-size: 22px;}
    .el-radio-group {display: flex}
    .el-radio {
      display:flex;align-items: center;
      .el-radio__label {
         display:flex;align-items: center;font-size: 18px;
      }
    }
    .ewm {
      text-align:center;margin-top:20px;
      img {width:200px;height:200px;}
    }
    .tip {text-align: center;font-size: 14px;margin-top:10px;}
}
</style>
